import React from "react";
import {
  CreateRequiredSubmittals,
  GetRequiredSubmittals,
  UpdatedRequiredSubmittals,
  UpdateRequiredSubmittalsActiveStatus,
} from "../../../axios";
import {
  AddIcon,
  AlertMessage,
  BreadCrumbs,
  FormTextInput,
  IconButton,
  Modal,
  NodataFound,
  SearchTable,
} from "../../../components";
import { SubmitalsForm } from "../../../forms";
import "../../../styles/tablepagination.css";
import { default as Strings, default as strings } from "../../../translations";

import TablePagination from "@mui/material/TablePagination";
import swal from "sweetalert";
import LoaderComponent from "../../../components/common/Loader";
import { isAuthorizedFunc } from "../../../utils";
import {
  CHANGE_STATUS_REQUIRED_SUBMITTALS,
  CREATE_REQUIRED_SUBMITTALS,
  UPDATE_REQUIRED_SUBMITTALS,
} from "../../../utils/constants";
import { FirstPage, KeyboardArrowLeft, KeyboardArrowRight, LastPage } from "@mui/icons-material";

function SearchSubMitalPage() {
  const searchFunctionTitle = Strings["SubMital.DashboardTitle"],
    alertMessage = Strings["SubMital.AlertMessage"],
    alertTitle = Strings["SubMital.AlertTitle"],
    tableName = Strings["SubMital.TableHead.tableName"],
    tag = Strings["SubMital.TableHead.tag"],
    description = Strings["SubMital.TableHead.description"],
    activeStatus = Strings["SubMital.TableHead.activeStatus"],
    action = Strings["SubMital.TableHead.action"];

  const [isOpen, setIsOpen] = React.useState(false);
  const [clickedBtn, setClickedBtn] = React.useState("");
  const [currentSubMital, setCurrentSubMital] = React.useState({});
  const [rows, setRows] = React.useState([]);
  const [editId, setEditId] = React.useState(null);
  const [alertBox, setAlertBox] = React.useState(false);
  const [isLoader, setisLoader] = React.useState(false);
  const [errorMessage, setMessage] = React.useState(null);
  const [currentStatus, setcurrentStatus] = React.useState(null);
  const [currentid, setcurrentid] = React.useState(null);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [totalData, setTotalData] = React.useState(null);
  const [isAdd, setAdd] = React.useState(true);
  const [isUpdate, setIsUpdate] = React.useState(true);
  const [isStatus, setIsStatus] = React.useState(true);
  const [searchValue, setSearchValue] = React.useState({
    value: "",
    error: false,
    success: false,
  });
  React.useEffect(() => {
    if (isAuthorizedFunc(CREATE_REQUIRED_SUBMITTALS)) {
      setAdd(true);
    } else {
      setAdd(false);
    }
  }, []);

  React.useEffect(() => {
    if (isAuthorizedFunc(UPDATE_REQUIRED_SUBMITTALS)) {
      setIsUpdate(true);
    } else {
      setIsUpdate(false);
    }
  }, []);

  React.useEffect(() => {
    if (isAuthorizedFunc(CHANGE_STATUS_REQUIRED_SUBMITTALS)) {
      setIsStatus(true);
    } else {
      setIsStatus(false);
    }
  }, []);

  const paths = [
    {
      name: strings["MasterConfigurationText"],
      path: "master-configuration",
    },
    {
      name: strings["RequiredSubmittals"],
      path: "master-configuration/searchsubmitals",
    },
  ];
  const mapableData = [
    {
      dataKey: "name",
      title: tableName,
    },
    {
      dataKey: "description",
      title: description,
    },
    {
      dataKey: "tag",
      title: tag,
    },
    {
      dataKey: "activeStatus",
      title: activeStatus,
      isStatus: true,
    },
    {
      dataKey: "id",
      title: action,
      isAction: true,
    },
  ];
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };
  const openAddModal = () => {
    setIsOpen(true);
  };
  const handleModalClose = () => {
    setMessage(null);
    setIsOpen(false);
  };

  const handleSelectBtn = (btn) => {
    setClickedBtn(btn);
  };

  const handleChangeActiveStatus = (id, statuss) => {
    setAlertBox(true);
    setcurrentStatus(statuss);
    setcurrentid(id);
  };
  //Api
  //create
  const createRequiredSubmittals = (formData) => {
    setisLoader(true);
    CreateRequiredSubmittals(formData)
      .then((res) => {
        if (res.status === 200) {
          setisLoader(false);
          swal({
            title: "Success!",
            text: res.data.message,
            icon: "success",
          });
          setRows([res.data.data, ...rows]);
          handleModalClose();
        }
      })
      .catch((e) => {
        setisLoader(false);
        setMessage(e.response.data.message);
      });
  };
  //update
  const updateRequiredSubmittals = (formData) => {
    setisLoader(true);
    UpdatedRequiredSubmittals(formData, editId)
      .then((res) => {
        if (res.status === 200) {
          setisLoader(false);
          const result = rows.map((elem) => {
            if (elem.id === res.data.data.id) {
              return {
                ...elem,
                name: res.data.data.name,
                description: res.data.data.description,
                tag: res.data.data.tag,
              };
            } else {
              return elem;
            }
          });
          swal({
            title: "Success!",
            text: res.data.message,
            icon: "success",
          });
          setRows(result);
          handleModalClose();
        }
      })
      .catch((e) => {
        setisLoader(false);
        setMessage(e.response.data.message);
      });
  };

  const getAlldata = () => {
    setisLoader(true);
    GetRequiredSubmittals(rowsPerPage, page, searchValue.value)
      .then((res) => {
        const data = res.data.data;
        setisLoader(false);
        setRows(data);
        setTotalData(res.data.total);
      })
      .catch(() => {
        setisLoader(false);
      });
  };
  React.useEffect(() => {
    getAlldata();
  }, [page, rowsPerPage]);

  const selectModal = () => {
    return (
      <SubmitalsForm
        setMessage={setMessage}
        errorMessage={errorMessage}
        handleChangeFormData={
          clickedBtn === "add"
            ? createRequiredSubmittals
            : updateRequiredSubmittals
        }
        actionType={clickedBtn}
        initialValue={clickedBtn !== "add" ? currentSubMital : {}}
        handleModalClose={handleModalClose}
      />
    );
  };

  const handleChangeCancel = () => {
    setAlertBox(false);
  };

  const handleChangeSuccess = () => {
    setisLoader(true);
    UpdateRequiredSubmittalsActiveStatus(
      { status: 1 - currentStatus },
      currentid
    )
      .then((res) => {
        setisLoader(false);
        const result = rows.map((elem) => {
          if (elem.id === res.data.data.id) {
            return { ...elem, is_active: res.data.data.is_active };
          } else {
            return elem;
          }
        });
        setRows(result);
        setAlertBox(false);
      })
      .catch((e) => {
        setisLoader(false);
      });
  };
  const handleChangeEdit = (id) => {
    openAddModal();
    const result = rows.find((row) => {
      return row.id === id;
    });
    setCurrentSubMital(result);
    setEditId(result.id);
    handleSelectBtn("edit");
  };
  const handleSearch = (searchData) => {
    const data = searchData.value;
    setSearchValue(searchData);
    if (searchData.value === "") {
      setisLoader(true);
      GetRequiredSubmittals(rowsPerPage, page, searchData.value)
        .then((res) => {
          const data = res.data.data;
          setisLoader(false);
          setRows(data);
          setTotalData(res.data.total);
        })
        .catch(() => {
          setisLoader(false);
        });
    }
    // const filterData = tempData.filter((d) => {
    //     return d[searchProp].toLowerCase().includes(data);
    // })
    // if (data === "") {
    //   setAllData(tempData);
    // } else {
    //   setAllData(filterBuilderData(allData, query));
    // }
  };
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    getAlldata();
  };

  function CustomTablePaginationActions(props) {
    const { count, page, rowsPerPage, onPageChange } = props;
  
    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };
  
    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };
  
    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };
  
    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
  
    return (
      <div style={{ flexShrink: 0, marginLeft: '1rem' }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          <FirstPage />
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          <KeyboardArrowLeft />
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          <KeyboardArrowRight />
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          <LastPage />
        </IconButton>
      </div>
    );
  }

  return (
    <>
      <div className="container">
        {isLoader ? <LoaderComponent /> : null}
        <Modal onHandleClose={handleModalClose} isOpen={isOpen}>
          {selectModal()}
        </Modal>
        <div className="row mt-4">
          <div className="col">
            <h3> {searchFunctionTitle} </h3>
            <BreadCrumbs pathList={paths} />
          </div>
          {isAdd && (
            <div className="col-auto">
              <span className="addButton">
                <IconButton
                  onClick={() => {
                    openAddModal();
                    handleSelectBtn("add");
                  }}
                >
                  <AddIcon />
                </IconButton>
              </span>
            </div>
          )}
          <div className="row">
            {alertBox && (
              <AlertMessage
                title={alertTitle}
                message={alertMessage}
                onChangeCancel={handleChangeCancel}
                onChangeSucess={handleChangeSuccess}
              />
            )}
            <div className="col-12">
              <div className="UserbudgetTable">
                <form onSubmit={handleSearchSubmit}>
                  <FormTextInput
                    type="text"
                    className="searchBarUser mb-3"
                    placeholder={`Search `}
                    Value={searchValue.value}
                    onChangeText={handleSearch}
                    inputStyle={{ border: "none" }}
                    editable
                  />
                </form>
                {rows.length !== 0 ? (
                  <>
                    <SearchTable
                      isUpdate={isUpdate}
                      isStatus={isStatus}
                      placeholder={"Submittal Name"}
                      data={rows}
                      mapableData={mapableData}
                      searchProp={["name"]}
                      handleChangeActiveStatus={handleChangeActiveStatus}
                      handleChangeEdit={handleChangeEdit}
                    />
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 15]}
                      component="div"
                      count={totalData}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={CustomTablePaginationActions}
                    />
                  </>
                ) : (
                  <>
                    {isLoader ? (
                      <LoaderComponent />
                    ) : (
                      <NodataFound
                        onClick={() => {
                          openAddModal();
                          handleSelectBtn("add");
                        }}
                      />
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
          {/* <Footer /> */}
        </div>
      </div>
    </>
  );
}

export default SearchSubMitalPage;
